export const TOOLTIP_YOUR_MAIN_DOMAIN = "project.creation.tooltip.your.main.domain";
export const TOOLTIP_MAKE_MAIN_DOMAIN = "project.creation.tooltip.make.main.domain";
export const TOOLTIP_EDIT_DOMAIN = "project.creation.tooltip.edit.domain";
export const TOOLTIP_REMOVE_FROM_LIST = "project.creation.tooltip.remove.from.list";
